import Vue from 'vue';
import Router from 'vue-router';
import GenericRedirectView from '@/components/GenericRedirectView';

import dashboardRoutes from '@/modules/dashboard/routes';
import courseRoutes from '@/modules/course/routes';
import memolanguageRoutes from '@/modules/memolanguage/routes';
import accountRoutes from '@/modules/account/routes';
import socialRoutes from '@/modules/social/routes';
import memoransierRoutes from '@/modules/memoransier/routes';
import memoryIQRoutes from '@/modules/memoryiq/routes';
import memogeniusGameRoutes from '@/modules/memogenius-game/routes';

import memoSystemRoutes from '@/modules/systems/routes';

import GamesView from '@/GamesView';
import MemoBot from '@/modules/game-faces/MemoBot';

Vue.use(Router);

const branch = process.env.GIT_BRANCH;

export default new Router({
    mode: 'history',
    base: window.location.pathname.startsWith(`/${branch}/`) ? `/${branch}/` : '/',

    routes: [
        {
            path: '/games',
            component: GamesView
        },

        {
            path: '/',
            redirect: { name: 'DashboardHomeView' }
        },
        {
            path: '/-dummy-',
            name: 'RouteDataError',
            redirect: { name: 'DashboardHomeView' }
        },
        {
            path: '/-dummy-',
            name: 'RouteAccessError',
            redirect: { name: 'DashboardHomeView' }
        },

        {
            path: '/generic-redirect',
            name: 'GenericRedirectView',
            component: GenericRedirectView
        },

        {
            path: '/memobot',
            name: 'MemoBot',
            component: MemoBot,
            meta: {
                requiresAuth: true
            }
        },

        ...dashboardRoutes,
        ...courseRoutes,
        ...memolanguageRoutes,
        ...accountRoutes,
        ...socialRoutes,
        ...memoransierRoutes,
        ...memoryIQRoutes,
        ...memogeniusGameRoutes,

        ...memoSystemRoutes,

        {
            path: '*',
            redirect: { name: 'DashboardHomeView' },
            meta: {
                requiresAuth: false
            }
        }
    ]
});
